import * as React from "react";
import { styled } from "@mui/material";
import { ChatWelcomePreview } from "../clinicSettings/chatWelcomePreview";
import {
  ClinicFormSettings,
  DefaultTemplateButton,
  MessageTextArea,
  MessageTextButtons,
  SectionBox,
  TemplateDialogProps,
  TemplateName,
} from "./clinicCustomization";
import { ThemeSettings } from "@kahunmedical/common-configuration";

//region [[ Styles ]]

const WelcomeScreenSettings = styled("div")({
  display: "flex",
  alignItems: "start",
  gap: 10,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicCustomizationTextsProps {
  settings: ClinicFormSettings;
  handleSettingsChange: (updated: ClinicFormSettings) => void;
  handelTemplateReset: (template: TemplateDialogProps) => void;
  customTheme: ThemeSettings;
  defaultWelcomeText: string;
  translate: any;
  rtlView: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicCustomizationTexts = ({
  settings,
  handleSettingsChange,
  rtlView,
  handelTemplateReset,
  customTheme,
  translate,
  ...props
}: ClinicCustomizationTextsProps) => {
  return (
    <SectionBox>
      <WelcomeScreenSettings>
        <div style={{ maxWidth: 600 }}>
          <strong>Welcome Screen Preview</strong>
          {/*<div id="kahun-patient" data-window-alignment="inline"></div>*/}
          <ChatWelcomePreview
            customTheme={customTheme}
            translate={translate}
            customWelcome={settings.customWelcome}
            rtlView={rtlView}
          />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <strong>Editable text</strong>
            <MessageTextButtons>
              <DefaultTemplateButton
                variant={"text"}
                size={"small"}
                id="useDefaultWelcomeText"
                onClick={() =>
                  handelTemplateReset({
                    methodName: "Welcome Message",
                    templateName: TemplateName.CustomWelcome,
                    templateDefault: props.defaultWelcomeText,
                  })
                }
                disabled={settings.customWelcome === props.defaultWelcomeText}
              >
                Use default
              </DefaultTemplateButton>
            </MessageTextButtons>
          </div>

          <MessageTextArea
            id="customWelcomeText"
            value={settings.customWelcome}
            variant="outlined"
            fullWidth
            multiline
            minRows={4}
            onChange={(e) =>
              handleSettingsChange({
                ...settings,
                customWelcome: e.target?.value,
              })
            }
            inputProps={{
              style: { direction: rtlView ? "rtl" : "inherit" },
            }}
          />
        </div>
      </WelcomeScreenSettings>
    </SectionBox>
  );
};
